import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuthState, PartnerAccesses, User } from 'app/auth/types';
import LocalStorageService from 'services/localStorageService';

const initialState: AuthState = {
  user: LocalStorageService.get('user'),
  isTFAEnabled: false,
  isAuthenticated: false,
  partnerAccesses: [],
  isPasswordExpired: false,
  isTokenChanged: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuth(state) {
      state.isAuthenticated = true;
    },
    clearAuth(state) {
      state.isAuthenticated = false;
      state.user = null;
    },
    setUser(state, action: PayloadAction<User>) {
      state.user = action.payload;
    },
    setAuthenticated(state, action: PayloadAction<boolean>) {
      state.isAuthenticated = action.payload;
    },
    changeTFAState(state, action: PayloadAction<boolean>) {
      state.isTFAEnabled = action.payload;
    },
    changeTokenState(state, action: PayloadAction<boolean>) {
      state.isTokenChanged = action.payload;
    },
    setPasswordExpired(state, action: PayloadAction<boolean>) {
      state.isPasswordExpired = action.payload;
    },
    setAuthUserPartnerAccesses(state, action: PayloadAction<PartnerAccesses>) {
      state.partnerAccesses = action.payload;
    },
  },
});

export const {
  setAuth, clearAuth, setUser, changeTFAState, setPasswordExpired,
  changeTokenState,
  setAuthenticated,
  setAuthUserPartnerAccesses,
} = authSlice.actions;
export default authSlice.reducer;
